const fecalHemoglobin = {
  parameters: [
    {
      name: 'fecalHemoglobin',
      displayName: 'Fecal Hemoglobin',
      id: 'fecalHemoglobin',
      validFrom: '2023/07/25 0:00',
      validThrough: null,
      stringValuesSupported: [
        'positive',
        'negative',
        'fault',
      ],
      outcomes: [{
        color: '#1f7359',
        description: 'fecalHemoglobin-negative',
        name: 'negative',
        displayInterpretation: 'Negative',
      },
      {
        color: '#f52d0a',
        description: 'fecalHemoglobin-positive',
        name: 'positive',
        displayInterpretation: 'Positive',
      },
      {
        color: '#000000',
        description: 'fecalHemoglobin-fault',
        name: 'fault',
        displayInterpretation: 'Fault',
      }],
    },
  ],
};

export default fecalHemoglobin;